import { useEffect, useState } from 'react'
import { useSeller } from '@/contexts/seller'
import { SidebarMenuItem } from '@/resources/types'
import { newSideBarItems } from '@/components/business/SidebarMenu/constants'
import useSidebarScheduledHandler from './useSidebarScheduledHandler'

export default function useSidebarLinks() {
  const [links, setLinks] = useState<SidebarMenuItem[]>([])
  const [isReady, setIsReady] = useState(false)

  const useSellerProps = useSeller()
  const { isFetchedSeller } = useSellerProps

  const { handleScheduledMenuItem } = useSidebarScheduledHandler({
    useSeller: useSellerProps,
    menuItems: links,
    setMenuItems: setLinks,
  })

  useEffect(() => {
    if (isFetchedSeller) {
      setIsReady(true)
    }
  }, [isFetchedSeller])

  const hasPermissionToShow = ({ shouldDisable }: SidebarMenuItem) => {
    if (!shouldDisable) return true

    return !shouldDisable(useSellerProps)
  }

  const mapSidebarItems = () => {
    const visibleItems: SidebarMenuItem[] = []

    newSideBarItems.forEach(menuItem => {
      if (!hasPermissionToShow(menuItem)) return
      const item: SidebarMenuItem = { ...menuItem }
      handleScheduledMenuItem(menuItem)
      visibleItems.push(item)
    })
    setLinks(visibleItems)
  }

  if (isReady && links.length === 0) {
    mapSidebarItems()
  }

  return { isReady, links }
}
